/**
 * User API
 */
import { apiClient } from '@/shared/api/client';
import {
    GetUserListResponseDto,
    CreateUserRequestDto,
    UpdateUserRequestDto,
    UserDto
} from '../types/user.types';

const BASE_PATH = '/api/v1/system/user';

/**
 * User API 서비스
 */
export const userApi = {
    /**
     * 사용자 목록 조회
     * GET /api/v1/system/user/list
     */
    getUserList: async (params?: {
        userId?: string;
        userName?: string;
        prmCode?: string;
        useYn?: string;
        suppName?: string;
    }): Promise<GetUserListResponseDto> => {
        const response = await apiClient.get<GetUserListResponseDto>(
            `${BASE_PATH}/list`,
            { params }
        );
        return response.data;
    },

    /**
     * 사용자 상세 조회
     * GET /api/v1/system/user/{userId}
     */
    getUser: async (userId: string): Promise<UserDto> => {
        const response = await apiClient.get<UserDto>(
            `${BASE_PATH}/${userId}`
        );
        return response.data;
    },

    /**
     * 사용자 생성
     * POST /api/v1/system/user/regist
     */
    createUser: async (request: CreateUserRequestDto, insertUserId?: string): Promise<{ success: boolean; message: string }> => {
        const requestWithInsertUserId = {
            ...request,
            userId: request.userId,
            insertUserId: insertUserId || ''
        };
        const response = await apiClient.post<{ success: boolean; message: string }>(
            `${BASE_PATH}/regist`,
            requestWithInsertUserId
        );
        return response.data;
    },

    /**
     * 사용자 수정
     * POST /api/v1/system/user/update
     */
    updateUser: async (userId: string, request: UpdateUserRequestDto, updateUserId?: string): Promise<{ success: boolean; message: string }> => {
        const requestWithUpdateUserId = {
            ...request,
            userId,
            updateUserId: updateUserId || ''
        };
        const response = await apiClient.post<{ success: boolean; message: string }>(
            `${BASE_PATH}/update`,
            requestWithUpdateUserId
        );
        return response.data;
    },

};
